var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11.907 18.792c.782-1.062 1.405-2.76 1.762-4.813h4.39a9.021 9.021 0 01-6.152 4.813zM1.939 13.98H6.33c.356 2.053.979 3.751 1.762 4.813a9.026 9.026 0 01-6.154-4.813zM8.093 1.21C7.31 2.27 6.687 3.968 6.33 6.02H1.939a9.026 9.026 0 016.154-4.813zM10 1c.893 0 2.078 1.875 2.654 5.021h-5.31c.578-3.146 1.762-5.02 2.656-5.02zm-9 9c0-1.062.194-2.075.533-3.02h4.653A24.06 24.06 0 006 10c0 1.054.066 2.068.186 3.021H1.533A8.926 8.926 0 011 10.001zm6.194 3.021A23.017 23.017 0 017 10.001c0-1.092.072-2.1.194-3.022h5.61C12.929 7.9 13 8.91 13 10s-.072 2.1-.195 3.021H7.194zM10 19.001c-.894 0-2.078-1.876-2.655-5.022h5.309C12.078 17.125 10.893 19 10 19zm9-9a8.975 8.975 0 01-.532 3.02h-4.655c.12-.953.187-1.967.187-3.02a24.25 24.25 0 00-.187-3.022h4.655C18.805 7.925 19 8.94 19 10zm-.94-3.98h-4.39c-.357-2.053-.98-3.75-1.762-4.813a9.025 9.025 0 016.154 4.813zM10 .001C4.477 0 0 4.477 0 10c0 5.521 4.477 9.998 10 10 5.523 0 10-4.479 10-10 0-5.524-4.477-10-10-10z"
  }))));
}
SvgLanguage.displayName = 'Language';
export default SvgLanguage;